import { Component, OnInit } from "@angular/core";
import { BaseComponent, UserService, ProductService, WindowService, environment, HelperService, CheckoutService, EventBusService, ProductLicenseItem, SimpleProduct } from "@mypxplat/xplat/core";
import { filter, take, takeUntil } from "rxjs/operators";
import { AppService, AvoService, WebErrorHandler } from "@mypxplat/xplat/web/core";
import { UpdatePaymentSourceStripeComponent, CancelSubscriptionStripeComponent, ConfirmPlanSwitchComponent, RechargeOptionsComponent } from "../../../modals";
import { ProductDetail } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { CurrencyPipe } from "@angular/common";
import { addMonths } from "date-fns";
import { Router } from "@angular/router";

declare var Stripe;

@Component({
  selector: "myp-account-play-plan",
  templateUrl: "./play-plan.component.html",
  standalone: false,
})
export class PlayPlanComponent extends BaseComponent implements OnInit {
  public statusMap = {
    active: { title: "Active", color: "green" },
    canceled: { title: "Canceled", color: "red" },
    cancelled: { title: "Canceled", color: "red" },
    unpaid: { title: "UnPaid", color: "orange" },
    past_due: { title: "Past Due", color: "orange" },
    incomplete: { title: "Incomplete", color: "orange" },
    expired: { title: "Expired", color: "gray" },
    incomplete_expired: { title: "Incomplete And Expired", color: "red" },
    trialing: { title: "Trailing", color: "orange" },
    ended: { title: "Expired", color: "gray" },
    pending: { title: "Pending", color: "orange" },
    "missed payment": { title: "Missed Payment", color: "orange" },
  };

  public subscriptionProduct: ProductLicenseItem;
  public defaultCard: any;
  public loading: boolean = true;
  public noSubscriptionFound: boolean = false;
  public nextChargeDate: any;
  public editingExpDetails: any = false;
  public expDetails: any = {};
  public proratedTotal: any;
  public formatedProratedTotal: any;
  public prorationDate: any;
  public clientSecret: string;
  public subscriptionId: string;
  public stripe: any;
  public priceList: any;
  public isConverted: boolean = false;
  public convertedAmount: any;
  public isTaxIncluded: boolean = false;
  public monthDifference: number;
  public loadingPaymentMethod: boolean = false;
  public loadingPaymentMethodSuccess: boolean = false;
  public paymentMethodLineItemLoaders: any = {};
  public missedPaymentDetails: any;
  public hybridElligible: boolean;
  public bundleTimeProgress: any;
  public bundleDaysLeft: number;
  public today: Date;
  public realDiscountEnd: Date;
  public activeStudioOneVersion: string;
  public gettingLicenseDetails: boolean = false;
  public showReactivateButton: boolean = false;
  public showCancelButton: boolean = false;

  public nextInvoice: any;
  public pastInvoices: any[] = [];
  public sub: any;

  constructor(
    public userService: UserService,
    public appService: AppService,
    public spinner: NgxSpinnerService,
    public productService: ProductService,
    private _win: WindowService,
    public translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    public avoService: AvoService,
    public helperService: HelperService,
    public errorService: WebErrorHandler,
    public checkoutService: CheckoutService,
    private _router: Router,
    private _eventbusService: EventBusService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.userService.getStorageDetails().subscribe();
    // this.stripe = Stripe(environment.stripe.public_key);
    this.loading = true;
    this.userService.subDetails$
      .pipe(
        filter((items) => !!items),
        take(1)
      )
      .subscribe((result) => {
        this.init();
      });
    // this.userService.getSubscriptionDetails(true).subscribe(() => (this.loading = false));
  }

  init(callBack?) {
    this.sub = this.userService.subDetails.play_subscription_normalized;
    this.loading = false;
    if (this.sub && this.sub.invoices?.length && this.sub.status == "active") {
      this.nextInvoice = this.sub.invoices.find((invoice) => new Date(invoice.periodStartDate) > new Date());
      this.pastInvoices = this.sub.invoices.filter((invoice) => new Date(invoice.periodStartDate) < new Date());
    }
  }

  cancelSubscription() {
    const modalRef = this.appService.showModal(CancelSubscriptionStripeComponent, { size: "lg" });
    modalRef.componentInstance.canceled.pipe(take(1)).subscribe((result) => {
      this.avoService.trackEvent().orderCanceled({
        userId_: this.userService.subDetails.subscription.Customer_id,
        prsId: this.userService.subDetails.subscription.Customer_id,
        prsSubStatus: this.userService.subDetails.subscription.status,
        subProvider: this.userService.subDetails.subscription.provider,
        subStartDate: this.userService.subDetails.subscription.start_date,
        subEndDate: this.userService.subDetails.subscription.end_date,
        subType: this.userService.subDetails.subscription.type,
        subCancelReason: result.subCancelReason,
        subCancelDetails: result.subCancelDetails,
      });
      this.spinner.show();
      this.userService.getSubscriptionDetails(true).subscribe(() => {
        this.computeShouldShowReactivateButton();
        this.spinner.hide();
      });
    });
  }

  upgrade() {
    this._router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }

  previewSwitchPlanPrice() {
    const modalRef = this.appService.showModal(ConfirmPlanSwitchComponent, { size: "lg" });
    modalRef.componentInstance.planSwitched.subscribe((_) => {
      this.spinner.show();
      this.userService.getSubscriptionDetails(true).subscribe(() => {
        this.spinner.hide();
      });
    });
  }

  deactivate(activation: any, mixer?) {
    this._win
      .confirm(this.translate.instant("sphere.account.remove_activation_confirm"))
      .then((_) => {
        let args: any = {
          activationId: activation.id,
        };
        if (mixer) {
          args.hardwareSerial = activation.hardwareSerialNumber;
        } else {
          args.assetId = activation.licenseId;
        }
        activation.loading = true;
        this.productService.deactivateSoftware(args).subscribe((result) => {
          this.productService.getLicenseDetails(this.userService.subDetails.subscription.Asset_id).subscribe((result: { product: SimpleProduct; license: ProductLicenseItem }) => {
            activation.loading = false;
            this.subscriptionProduct = result.license;
            this.computeShouldShowReactivateButton();
          });
        });
      })
      .catch((_) => {});
  }

  reactivate() {
    let reactivate = {
      subscription_id: this.userService.subDetails.stripe_subscription.id,
      source: "myp_upgrade",
    };
    this.spinner.show();
    this.userService.reactivateSubscription(reactivate).subscribe((result: any) => {
      if (result.subscriptions) {
        this.userService.getSubscriptionDetails(true).subscribe(() => {
          this.computeShouldShowReactivateButton();
          this.spinner.hide();
        });
      }
    });
  }

  setCardAsDefault(paymentMethodId) {
    this.paymentMethodLineItemLoaders[paymentMethodId] = true;
    this.userService.setDefaultPaymentMethod(paymentMethodId).subscribe({
      next: (result) => {
        this.userService.getSubscriptionDetails(true).subscribe(() => {
          this.spinner.hide();
          this.paymentMethodLineItemLoaders[paymentMethodId] = false;
          this.loadingPaymentMethod = false;
          this.loadingPaymentMethodSuccess = true;
          this._win.setTimeout(() => {
            this.loadingPaymentMethodSuccess = false;
          }, 2000);
        });
      },
      error: (error) => {
        this.paymentMethodLineItemLoaders[paymentMethodId] = false;
        this.loadingPaymentMethod = false;
        alert(error);
      },
    });
  }

  deletePaymentMethod(paymentMethodId) {
    if (confirm("Are you sure you want to delete this payment method?")) {
      this.paymentMethodLineItemLoaders[paymentMethodId] = true;
      this.checkoutService.deletePaymentMethod(paymentMethodId).subscribe(() => {
        this.userService.getPaymentMethods(true).subscribe((result) => {
          this.paymentMethodLineItemLoaders[paymentMethodId] = false;
        });
      });
    }
  }

  rechargePaymentOptions() {
    const modalRef = this.appService.showModal(RechargeOptionsComponent, { size: "xl" });
  }

  goToAddPaymentMethod() {
    window.location.assign("/paymentmethod");
  }

  setupSchedule() {
    let sixMonthsLater = addMonths(new Date(this.userService.subDetails.subscription.end_date), 6);
    let details = {
      time: this.userService.subDetails.subscription.bundle_time,
      subscription_start_date: this.userService.subDetails.subscription.end_date,
      annual_upgrade_subscription_start_date: sixMonthsLater,
    };
    this.checkoutService.scheduleDetails = details;
    if (this.userService.subDetails?.subscription?.subscription_levels_id == 2) this.checkoutService.selectedS1PlusPlan = "annual";
    this.appService.goToCheckout("/checkout?showScheduleOptions=true");
  }

  computeShouldShowReactivateButton(): void {
    const subscription = this.userService.subDetails?.subscription;
    const stripeSub = this.userService.subDetails?.stripe_subscription;

    if (!subscription || !stripeSub) {
      this.showReactivateButton = false;
      this.showCancelButton = false;
      return;
    }

    const hasDbCancelStatus = this.statusMap[subscription.status]?.title === "Canceled";
    const stripeCancelAtPeriodEnd = stripeSub.cancel_at_period_end === true;

    this.showReactivateButton = hasDbCancelStatus || stripeCancelAtPeriodEnd;

    const stripeStatus = stripeSub.status;
    const isFailed = stripeStatus === "failed";
    const isCanceled = this.statusMap[stripeStatus]?.title === "Canceled";

    this.showCancelButton = !!stripeSub && (!stripeStatus || !isFailed) && !isCanceled && stripeSub.cancel_at_period_end !== true;
  }
}

function monthDiff(startingDate, endingDate) {
  let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
  if (!endingDate) {
    endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
  }
  let endDate = new Date(endingDate);
  if (startDate > endDate) {
    const swap = startDate;
    startDate = endDate;
    endDate = swap;
  }
  const startYear = startDate.getFullYear();
  const february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
  const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  let monthDiff = endDate.getMonth() - startDate.getMonth();
  if (monthDiff < 0) {
    monthDiff += 12;
  }
  let dayDiff = endDate.getDate() - startDate.getDate();
  if (dayDiff < 0) {
    if (monthDiff > 0) {
      monthDiff--;
    } else {
      monthDiff = 11;
    }
    dayDiff += daysInMonth[startDate.getMonth()];
  }

  return monthDiff;
}
